import Vue from 'vue';
import moment from 'moment-timezone';
import _ from 'lodash';

Vue.filter('ago', (value) => {
  if (value && moment(String(value)).isBefore()) {
    return moment(String(value)).fromNow();
  } else {
    return '';
  }
});

Vue.filter('dateFormat', (value) => {
  if (value) {
    return moment(value).format('lll z');
  } else {
    return '';
  }
});

Vue.filter('longDateFormat', (value, timeZone) => {
  if (value) {
    return moment.tz(value, timeZone).format('YYYY-MM-DD hh:mm:ss a z');
  } else {
    return '';
  }
});

Vue.filter('shortDateFormat', (value) => {
  if (value) {
    return moment(value).format('MMM Do LT z');
  } else {
    return '';
  }
});

Vue.filter('money', (value) => {
  if (value) {
    return value.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
  }
  return '$0.00';
});

Vue.filter('rounded', (value) => {
  if (value) {
    return value.toLocaleString('en-US', {
      maximumFractionDigits: 2,
    });
  }
  return '';
});

Vue.filter('startCase', (value) => {
  if (value) {
    return _.startCase(value);
  }
  return '';
});
